import React, { Component } from 'react';
import config from '../../config/config';

import act1 from '../../assets/images/activity/act1@2x.png';
import act2 from '../../assets/images/activity/act2@2x.png';
// import act3 from '../../assets/images/activity/act3@2x.png';
import act6 from '../../assets/images/activity/act6@2x.png'

class Swiper extends Component {
  state = {
    activityMap: [{
      img: act1,
      link: `${config.backendUrl}/spreadAssist/intro`
    }, {
      img: act2,
      link: `${config.backendUrl}/spreadAssist/apply`
    }, {
      img: act6,
      link: `${config.backendUrl}/spreadAssist/qr`
    },
    //   {
    //   img: act4,
    //   link: 'https://mfbd.fujfu.com/newUser?channelCode=activity-xh-zt-20210601'
    // }
    ],
  }

  render () {
    const len = this.state.activityMap.length;
    const width = (len * 3) + (len - 1) * 0.18;
    return (
      <div className='act-detail'>
        <div className='act-wrap' style={{ 'width': `${width}rem` }}>
          {
            this.state.activityMap.map((item, index) => {
              return (
                <a href={item.link} key={index}>
                  <img src={item.img} alt=''></img>
                </a>
              )
            })
          }
        </div>
      </div>
    )
  }
}

export default Swiper;
